// import OSS from 'ali-oss'
import { OSS_FILE } from '@/config/env'
import dayjs from 'dayjs'
import { uuid } from 'utils/index'
import { message } from 'ant-design-vue'

let client = function () {}
//
// initData().then()
//
// async function initData() {
//   let res = await import('ali-oss')
//   // .then((res) => {
//   client = new res.default({
//     region: OSS_FILE.OSS_REGION,
//     accessKeyId: OSS_FILE.OSS_KEY_ID,
//     accessKeySecret: OSS_FILE.OSS_KEY_SECRET,
//     bucket: OSS_FILE.OSS_BUCKET,
//   })
//   console.log(client)
//   // })
// }
import(/* webpackChunkName: "ali-oss" */ 'ali-oss').then((res) => {
  client = new res.default({
    region: OSS_FILE.OSS_REGION,
    accessKeyId: OSS_FILE.OSS_KEY_ID,
    accessKeySecret: OSS_FILE.OSS_KEY_SECRET,
    bucket: OSS_FILE.OSS_BUCKET,
  })
  // console.log(client)
})

export default client

/**
 * 文件上传方法
 * @param data file文件
 * @returns {Promise<void>}
 */
export const putObject = async (file) => {
  let res, err
  try {
    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    const name = file?.name.split('.') ?? []
    const key =
      'yeb/pc/' +
      dayjs().format('YYYY-MM-DD') +
      '/' +
      name[0] +
      '_-_' +
      uuid() +
      `${name.length > 1 && '.' + name[name.length - 1]}`
    console.log('上传开始 %s', key)
    // console.log(client)
    let result, tempCheckpoint
    if (file?.size / 1024 / 1024 > 10) {
      result = await client.multipartUpload(key, file, {
        progress: (p, checkpoint) => {
          message.loading({ content: `上传中 ${Math.floor(p * 100)}%`, key, duration: 0 })
          if (p === 1) {
            message.success({ content: '上传成功', key, duration: 3 })
          }
          // console.log(p)
          tempCheckpoint = checkpoint
        },
        checkpoint: tempCheckpoint,
      })
    } else {
      result = await client.put(key, file)
    }
    // console.log(result)
    // console.log(file)
    if (result.res.statusCode === 200) {
      if (!result.url) {
        result.url = 'https://' + client.options.bucket + '.' + client.options.region + '.aliyuncs.com/' + result.name
      }
      res = result
    } else {
      err = {}
      console.log('上传文件状态非200', result)
    }
  } catch (e) {
    err = {}
    console.error('file upload error %s', e)
  }
  return new Promise((resolve, reject) => {
    if (res) {
      resolve(res)
    }
    if (err) {
      reject(err)
    }
  })
}

/**
 * 文件上传
 */
export const uploadImage = async (file) => {
  try {
    const suffix = file?.name?.split('.')?.[1] || 'jpg'
    const key = `psImg/${dayjs().format('YYYY-MM-DD')}/${+new Date() + Math.floor(Math.random() * 10000)}.${suffix}`

    let tempCheckpoint
    if (file?.size / 1024 / 1024 > 10) {
      return await client.multipartUpload(key, file, {
        headers: {
          'Content-Type': 'image/jpg',
        },
        progress: (p, checkpoint) => {
          console.log({ content: `上传中 ${Math.floor(p * 100)}%`, key, duration: 0 })
          if (p === 1) {
            console.log({ content: '上传成功', key, duration: 3 })
          }
          tempCheckpoint = checkpoint
        },
        checkpoint: tempCheckpoint,
      })
    } else {
      return await client.put(key, file, {
        // 一定要加上请求头
        headers: {
          'Content-Type': 'image/jpg',
        },
      })
    }
  } catch (e) {
    console.log('[文件上传失败]: ', e)
  }
}
